import { useNavigate } from "react-router-dom";

/** Map an internal page id (e.g. "about") to its URL path. */
export const pathFor = (id) => (id === "home" || !id ? "/" : `/${id}`);

/** Map a URL pathname back to a page id (e.g. "/about" -> "about"). */
export const idForPath = (pathname) => {
  const seg = pathname.replace(/^\/+/, "").split("/")[0];
  return seg === "admissions-portal" ? "admissions" : seg || "home";
};

/**
 * Returns a `setPage(id)` function that navigates to the page's route and
 * scrolls to the top — a drop-in for the old state-based navigation.
 */
export function useSetPage() {
  const navigate = useNavigate();
  return (id) => {
    navigate(pathFor(id));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
}
